import { render, staticRenderFns } from "./company_pay_groups.vue?vue&type=template&id=28831116&scoped=true"
import script from "./company_pay_groups.vue?vue&type=script&lang=js"
export * from "./company_pay_groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28831116",
  null
  
)

export default component.exports